import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import {
  emptyContact,
  emptyNetwork,
  type PublicConfiguration,
} from '../../application/types';

type ConfigurationEnvelope = {
  data?: Partial<PublicConfiguration>;
};

export async function fetchPublicConfiguration(): Promise<PublicConfiguration> {
  const response = await createPublicClient().get<ConfigurationEnvelope>(
    '/app/configuration',
  );
  const data = response.data?.data;
  return {
    network: {
      ...emptyNetwork(),
      ...(data?.network ?? {}),
    },
    publicContacts: {
      ...emptyContact(),
      ...(data?.publicContacts ?? {}),
    },
    isPublicOffer: Boolean(data?.isPublicOffer),
    cachedAt: data?.cachedAt ?? '',
  };
}
